var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",on:{"click":function($event){return _vm.click()}}},[_vm._v(_vm._s(_vm.displayLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }